import { BatchAPI, BatchDataKVFeeds } from './../../models/apis/batchAPI';
import { useFeedApi } from "../../hooks/APIs";

export const getTiyuData = () => {
    const [cba] = useFeedApi(11752, 2);
    const [nba] = useFeedApi(11750, 2);
    const [zhongchao] = useFeedApi(11753, 2);
    const tiyuData = {};
    /* tslint:disable:no-string-literal */
    // FIXME: Orders are not strict, Fix me asap.
    tiyuData['NBA'] = nba;
    tiyuData['CBA'] = cba;
    tiyuData['中超'] = zhongchao;
    /* tslint:enable:no-string-literal */
    return tiyuData;
};

// TODO: Comments requried and function name should change.
export const generateData = (keys: string[], ids: number[], data: BatchAPI['body']): BatchDataKVFeeds => {
    const res: BatchDataKVFeeds = {};
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const id = ids[i];
        res[key] = (data.data[id] || {}).data || [];
    }
    return res;
};

export const timestampToTime = (timestamp: number) => {
    const date = new Date(timestamp);
    const Y = date.getFullYear();
    const M = date.getMonth() + 1;
    const D = date.getDate();
    return timestamp ? ` · ${Y}-${M}-${D}` : '';
};



// WEBPACK FOOTER //
// ./src/components/HomeTop/util.ts